import $ from 'jquery';
import { loadSelectTagsBackground } from '~src/sidebar/index';
// import { loadSelectFormatsBackground } from '~src/sidebar/index'; Deprecated: we do not longer tag backgrounds with formats

export const displayBackgroundManagerMultiTag = async () => {
  const selectTagsHtml = `
    <div id="tag-select-background">
      <select id="tagBackgroundSelectUpload" multiple="multiple"> </select>
    </div>
  `;
  $('#selectTag-background-container-multi-tag').html(selectTagsHtml);
  loadSelectTagsBackground();

  const selectFormatsHtml = `
    <div  id="format-select-background">
      <select id="formatBackgroundSelectUpload" multiple="multiple"> </select>
    </div>
  `;
  $('#selectFormat-background-container-multi-tag').html(selectFormatsHtml);
  // loadSelectFormatsBackground(); Deprecated: we do not longer tag backgrounds with formats
};
